import {
  ExternalLink,
  GraduationCap,
  HandCoins,
  Handshake,
  HeartCrack,
  MapPinHouse,
  Pickaxe,
  Plane,
  Scale,
  SparklesIcon,
} from 'lucide-react';
import SectionLayout from '../../layouts/SectionLayout';
import PracticeCard from './PracticeCard';
const PracticeArea = () => {
  const areas = [
    {
      title: 'Criminal Law',
      description:
        'Expert defense in criminal cases, from misdemeanors to complex federal crimes.',
      icon: <Scale className='size-7' />,
      imageSrc:
        'https://images.unsplash.com/photo-1532077795300-c4b487f601f6?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Y3JpbWV8ZW58MHx8NHx8fDI%3D', // Replace with criminal law related image
    },
    {
      title: 'Business Law',
      description:
        'Comprehensive legal solutions for businesses of all sizes, including contracts and compliance.',
      icon: <Handshake className='size-7' />,
      imageSrc:
        'https://images.unsplash.com/photo-1444653614773-995cb1ef9efa?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjJ8fGJ1c2luZXNzfGVufDB8fDR8fHwy', // Replace with business law related image
    },
    {
      title: 'Education Law',
      description:
        'Supporting institutions and students with specialized education law expertise.',
      icon: <GraduationCap className='size-7' />,
      imageSrc:
        'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Replace with education law related image
    },
    {
      title: 'Real Estate Law',
      description:
        'Strategic counsel for corporate governance, mergers, and regulatory compliance.',
      icon: <MapPinHouse className='size-7' />,
      imageSrc:
        'https://images.unsplash.com/photo-1448630360428-65456885c650?q=80&w=2067&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Replace with corporate law related image
    },
    {
      title: 'Family Law',
      description:
        'Compassionate representation in divorce, custody, and family matters.',
      icon: <HeartCrack className='size-7' />,
      imageSrc:
        'https://img.freepik.com/free-photo/wedding-rings-divorce-decree_23-2148542345.jpg?ga=GA1.1.1872001325.1717919742&semt=ais_hybrid', // Replace with family law related image
    },
    {
      title: 'Immigration Law',
      description:
        'Protecting individual rights and liberties through dedicated advocacy.',
      icon: <Plane className='size-7' />,
      imageSrc:
        'https://images.unsplash.com/photo-1561121864-3e4031788fdd?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Replace with civil rights related image
    },
    {
      title: 'Tax Law',
      description:
        'Protecting individual rights and liberties through dedicated advocacy.',
      icon: <HandCoins className='size-7' />,
      imageSrc:
        'https://images.unsplash.com/photo-1554224154-26032ffc0d07?q=80&w=2026&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Replace with civil rights related image
    },
    {
      title: 'Labor Law',
      description:
        'Protecting individual rights and liberties through dedicated advocacy.',
      icon: <Pickaxe className='size-7' />,
      imageSrc:
        'https://images.unsplash.com/photo-1540476547779-348beb642680?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Replace with civil rights related image
    },
  ];
  return (
    <SectionLayout
      id='practice-areas'
      titleFirstPart='What'
      titleSecondPart='We Offer'
    >
      <div className=' w-full h-full mt-14'>
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4'>
          {/* row 1 */}
          <div className=''>
            <PracticeCard {...areas[1]} />
          </div>
          <div className='  '>
            <PracticeCard {...areas[2]} />
          </div>
          <div className=' xl:col-span-2 '>
            <PracticeCard {...areas[0]} />
          </div>

          {/* row 2 */}
          <div className='  '>
            <PracticeCard {...areas[3]} />
          </div>
          <div className=' xl:col-span-2  '>
            <PracticeCard {...areas[5]} />
          </div>
          <div className='  '>
            <PracticeCard {...areas[4]} />
          </div>

          {/* row 3 */}
          <div className=' xl:col-span-2  '>
            <PracticeCard {...areas[6]} />
          </div>
          <div className='  '>
            <PracticeCard {...areas[7]} />
          </div>
          <div className=' '>
            <div
              className={`group border-2 border-legal-brown shadow-lg relative h-60 xl:h-72  overflow-hidden rounded-xl transition-all duration-500 hover:shadow-2xl`}
            >
              {/* Background Image */}
              <div className='absolute inset-0 bg-cover bg-gradient-to-t from-legal-dark-gray via-legal-dark-gray to-legal-dark-blue transition-transform duration-500 group-hover:scale-110' />

              {/* Title and Icon */}
              <div className='absolute inset-0 flex flex-col items-center justify-center p-4 text-center'>
                <div className='flex flex-col items-center transform transition-all duration-500 group-hover:scale-105'>
                  <div className='flex items-center gap-3'>
                    <div className='text-white/90'>
                      <SparklesIcon className='size-8 text-legal-white transition-transform duration-500 group-hover:rotate-12' />
                    </div>
                    <h3 className='text-2xl tracking-wide font-marcellus font-semibold text-white'>
                      And Many More
                    </h3>
                  </div>
                  <p className='mt-2 text-base font-marcellus text-white/80 max-w-xs'>
                    Discover additional features and benefits tailored just for
                    you.
                  </p>
                  <a
                    href='/'
                    className='mt-4 relative px-6 py-2 bg-transparent border-2 border-legal-brown text-white font-marcellus font-semibold rounded-lg transition-all duration-500 hover:scale-105 group-hover:text-legal-dark-blue hover:shadow-lg flex items-center gap-2'
                  >
                    <span>Discover More</span>
                    <ExternalLink className='size-5' />
                    <span className='absolute w-full h-0 -z-10 inset-x-0 bottom-0 transition-all duration-500 ease-out group-hover:h-full bg-legal-white rounded-md' />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionLayout>
  );
};

export default PracticeArea;
